export default "__VITE_ASSET__BO4x6SmM__"